// =====================================
//
//   超商付款 Controller
//   Author: Gray
//   createtime: 2017 / 10 / 30
//   updatetime: 2017 / 10 / 30
//
// =====================================

window.InifECMobileApp.controller("ExtrafeePaymentSpgatewayCvsController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'ExtraFeeService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, ExtraFeeService) {

        var getExtraFee = function() {

            $scope.isLoading = true;
            ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {

                if(result) {
                    $scope.extrafee = result;
                    $scope.orderid = $scope.extrafee.orderid;
                    
                    if($scope.extrafee.status != 300) {
                        $scope.isLoading = false;
                        $scope.isStatusError = true;
                    } else {
                        $scope.paidLimitTime = getPaidLimitTime($scope.extrafee);
                        pay();
                    }

                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }

            }, function(error) {
                if(error && error.code == 'error.itemIsNotExist') {
                    $scope.isExtrafeeNotExist = true;
                } else {
                    $scope.isError = true;
                }
                
                $scope.isLoading = false;
            });
        }

        var pay = function() {

            if(!$scope.extrafee) {
                $scope.isError = true;
                return;
            }

            // 現階段 超商代收不可超過兩萬，最低不可低於27
            if($scope.extrafee.totalamount > 20000 || $scope.extrafee.totalamount < 27) {
                $scope.isError = true;                
                return;
            }

            var extrafeeid = $scope.extrafeeid,
                paymentmethod = Paytype_Spgateway_Cvs,
                totalamount = $scope.extrafee.totalamount;

            ExtraFeeService.payExtraFee(extrafeeid, paymentmethod, totalamount).then(function(result) {
                if(result) {
                    // 處理ATM資料
                    try {
                        $scope.csvinfo = angular.fromJson(result.gatewayRstJSON);
                    } catch (e) {
                        console.log(e);
                    }

                    $scope.isLoading = false;
                    $scope.isError = false;
                    $scope.isComplete = true;
                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }             
            }, function(error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        var getPaidLimitTime = function(extrafee) {

            var startPaidTime = extrafee.createtime;

            if(startPaidTime > 0) {
                return startPaidTime + 60 * 60 * 24 * 1000 * 7;    
            } else {
                return 0;
            }
        }

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;
                getExtraFee();
            }, function(error) {
                $scope.isLogin = false;

                $state.go(window.STATES.HOME);
            });
        }

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.extrafeeid = $stateParams.extrafeeid;
        $scope.orderid = $stateParams.orderid;
        $scope.extrafee;
        $scope.csvinfo;
        $scope.isError = false;
        $scope.isLoading = false;
        $scope.isComplete = false;
        $scope.isExtrafeeNotExist = false;
        $scope.paidLimitTime = 0;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);